{% block acris_faq_group_detail %}
    <sw-page class="acris-faq-group-detail" v-if="item">

        {% block acris_faq_group_detail_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_faq_group_detail_smart_bar_header_title %}
                    <h2>{{ $tc('acris-faq-group.detail.textHeadline') }}</h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_faq_group_detail_smart_bar_language %}
            <template #language-switch>
                <sw-language-switch @on-change="onChangeLanguage"
                                    :disabled="$route.params.newItem"></sw-language-switch>
            </template>
        {% endblock %}

        {% block acris_faq_group_detail_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_faq_group_detail_smart_bar_actions_cancel %}
                    <mt-button :disabled="item.isLoading" @click="$router.push({ name: 'acris.faq.group.index' })"
                               size="default" variant="secondary">
                        {{ $tc('acris-faq-group.detail.buttonCancel') }}
                    </mt-button>
                {% endblock %}

                {% block acris_faq_group_detail_smart_bar_actions_save %}
                    <sw-button-process
                            class="acris-faq-group-detail__save-action"
                            :isLoading="isLoading"
                            :processSuccess="processSuccess"
                            variant="primary"
                            :disabled="item.isLoading || !item.name"
                            @update:processSuccess="saveFinish"
                            @click="onClickSave">
                        {{ $tc('acris-faq-group.detail.buttonSave') }}
                    </sw-button-process>
                {% endblock %}
            </template>
        {% endblock %}


        {% block acris_faq_group_detail_content %}
            <template #content>
                <sw-card-view>
                    {% block acris_faq_group_detail_content_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-faq-group-content"
                                 :title="$tc('acris-faq-group.detail.cardFaqGroup')">

                            {% block acris_faq_group_detail_content_name %}
                                <mt-text-field v-model="item.name"
                                               required
                                               class="acris-faq-group-detail__item_name"
                                               :label="$tc('acris-faq-group.detail.fieldTitleLabelName')"
                                               :placeholder="$tc('acris-faq-group.detail.fieldTitlePlaceholderName')">
                                </mt-text-field>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_description %}
                                <sw-text-editor type="textarea"
                                                v-model:value="item.description"
                                                class="acris-faq-group-detail__item_description"
                                                :label="$tc('acris-faq-group.detail.fieldTitleLabelDescription')"
                                                :placeholder="$tc('acris-faq-group.detail.fieldTitlePlaceholderDescription')">
                                </sw-text-editor>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_priority %}
                                <mt-number-field v-model="item.priority"
                                                 numberType="float"
                                                 class="acris-faq-group-detail__item_priority"
                                                 :label="$tc('acris-faq-group.detail.fieldTitleLabelPriority')"
                                                 :placeholder="$tc('acris-faq-group.detail.fieldTitlePlaceholderPriority')"
                                                 :helpText="$tc('acris-faq-group.detail.fieldTitleHelpTextPriority')">
                                </mt-number-field>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_active_checkbox_select %}
                                <mt-switch v-model="item.active"
                                           class="acris-faq-group-detail__item_active"
                                           :label="$tc('acris-faq-group.detail.fieldTitleLabelActive')"
                                           :helpText="$tc('acris-faq-group.detail.fieldTitleHelpTextActive')">
                                </mt-switch>
                            {% endblock %}

                            {% block acris_faq_detail_content_sales_channel %}
                                <sw-entity-many-to-many-select
                                        v-if="item.salesChannels"
                                        :localMode="true"
                                        :label="$tc('acris-faq-group.detail.fieldTitleLabelSalesChannel')"
                                        :helpText="$tc('acris-faq-group.detail.fieldTitleHelpTextSalesChannel')"
                                        :placeholder="$tc('acris-faq-group.detail.fieldTitlePlaceholderSalesChannel')"
                                        :entity-collection="item.salesChannels"
                                        @update:entity-collection="onSalesChannelChange">
                                </sw-entity-many-to-many-select>
                            {% endblock %}

                            {% block acris_faq_detail_content_rule %}
                                <sw-entity-many-to-many-select
                                        v-if="item.rules"
                                        :localMode="true"
                                        :label="$tc('acris-faq-group.detail.fieldTitleLabelRule')"
                                        :helpText="$tc('acris-faq-group.detail.fieldTitleHelpTextRule')"
                                        :placeholder="$tc('acris-faq-group.detail.fieldTitlePlaceholderRule')"
                                        :entity-collection="item.rules"
                                        @update:entity-collection="onRulesChange">
                                </sw-entity-many-to-many-select>
                            {% endblock %}
                        </mt-card>
                    {% endblock %}

                    {% block acris_faq_group_detail_content_card_visibility %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-faq-group-visibility"
                                 :title="$tc('acris-faq-group.detail.cardVisibility')">

                            {% block acris_faq_group_detail_visibility_name %}
                                <sw-single-select v-model:value="item.nameDisplay"
                                                  :options="displayOptions"
                                                  :label="$tc('acris-faq-group.detail.fieldTitleLabelNameDisplay')">
                                </sw-single-select>
                            {% endblock %}

                            {% block acris_faq_group_detail_visibility_description %}
                                <sw-single-select v-model:value="item.descriptionDisplay"
                                                  :options="displayOptions"
                                                  :label="$tc('acris-faq-group.detail.fieldTitleLabelDescriptionDisplay')">
                                </sw-single-select>
                            {% endblock %}

                            {% block acris_faq_group_detail_display_foldable %}
                                <sw-single-select v-model:value="item.displayFoldable"
                                                  :options="displayFoldableOptions"
                                                  :label="$tc('acris-faq-group.detail.fieldTitleLabelDisplayFoldable')">
                                </sw-single-select>
                            {% endblock %}

                        </mt-card>
                    {% endblock %}

                    {% block acris_faq_group_detail_content_card_products %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-faq-group-products"
                                 :title="$tc('acris-faq-group.detail.cardFaqGroupProducts')">

                            {% block acris_faq_detail_content_products %}
                                <acris-entity-many-to-many-select
                                        v-if="item.products"
                                        :localMode="true"
                                        :display-variants="true"
                                        :criteria="productCriteria"
                                        :context="productContext"
                                        :label="$tc('acris-faq-group.detail.fieldTitleLabelProduct')"
                                        :helpText="$tc('acris-faq-group.detail.fieldTitleHelpTextProduct')"
                                        :placeholder="$tc('acris-faq-group.detail.fieldTitlePlaceholderProduct')"
                                        :entity-collection="item.products"
                                        @update:entity-collection="onItemProductChange">

                                    {% block sw_select_result_item_text %}
                                        <template #selection-label-property="{ item }">
                                            <sw-product-variant-info :variations="item.variation"
                                                                     class="product-entity-selected">
                                                {{ item.productNumber }} - {{ item.translated.name || item.name }}
                                            </sw-product-variant-info>
                                        </template>
                                    {% endblock %}

                                    {% block sw_entity_many_to_many_select_base_results_list_result_label %}
                                        <template #result-label-property="{ item, index }">
                                            <sw-product-variant-info :variations="item.variation"
                                                                     class="product-entity-selected">
                                                {{ item.productNumber }} - {{ item.translated.name || item.name }}
                                            </sw-product-variant-info>
                                        </template>
                                    {% endblock %}

                                </acris-entity-many-to-many-select>


                                <h3 class="my-3">{{ $tc('acris-faq-group.detail.productOrProductGroup') }}</h3>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_products_group %}
                                <sw-entity-many-to-many-select
                                        v-if="item.productStreams"
                                        :localMode="true"
                                        :label="$tc('acris-faq-group.detail.fieldTitleLabelProductStreams')"
                                        :placeholder="$tc('acris-faq-group.detail.fieldTitlePlaceholderProductStreams')"
                                        :helpText="$tc('acris-faq-group.detail.fieldTitleHelpTextProductStreams')"
                                        :entity-collection="item.productStreams"
                                        @update:entity-collection="onProductStreamChange">
                                </sw-entity-many-to-many-select>
                            {% endblock %}

                        </mt-card>
                    {% endblock %}

                    {% block acris_faq_group_detail_content_card_categories %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 :title="$tc('acris-faq-group.detail.cardFaqGroupCategories')">

                            {% block acris_faq_group_detail_content_card_categories_selection %}
                                <sw-category-tree-field
                                        v-model:value="item.categories"
                                        class="sw-product-detail__select-category"
                                        :label="$tc('acris-faq-group.detail.fieldTitleLabelCategories')"
                                        :categories-collection="item.categories"
                                        :placeholder="$tc('acris-faq-group.detail.fieldTitlePlaceholderCategories')"
                                        @selection-add="onFooterSelectionAdd"
                                        @selection-remove="onFooterSelectionRemove"
                                >
                                </sw-category-tree-field>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_card_categories_display %}
                                <mt-select :label="$tc('acris-faq-group.detail.fieldTitleLabelCategoriesDisplay')"
                                           :options="optionsGroupDisplay"
                                           v-model="item.groupDisplay">
                                </mt-select>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_card_categories_info %}
                                <mt-banner
                                        v-if="item.groupDisplay == 'cmsElement'"
                                        class="acris-faq-group__display-info"
                                        variant="info">
                                    {{ $tc('acris-faq-group.detail.fieldTitleInfoTextCategories') }}
                                </mt-banner>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_card_categories_below_listing_info %}
                                <mt-banner
                                        v-if="item.groupDisplay == 'belowListing'"
                                        class="acris-faq-group__display-info"
                                        variant="info">
                                    {{ $tc('acris-faq-group.detail.infoTextCategoriesDisplayOptionBelow') }}
                                </mt-banner>
                            {% endblock %}
                        </mt-card>
                    {% endblock %}

                    {% block acris_faq_group_detail_faqs %}
                        <mt-card v-if="assignedFaqs.length > 0"
                                 position-identifier="acris-faq-group-faqs"
                                 :title="$tc('acris-faq-group.detail.cardFaqs')">

                            {#                <sw-data-grid #}
                            {#                    class="acris-faq-group-detail__assigned-faqs" #}
                            {#                    :data-source="assignedFaqs" #}
                            {#                    :columns="faqColumns" #}
                            {#                    :compact-mode="true" #}
                            {#                    :show-actions="true" #}
                            {#                    :show-selection="false" #}
                            {#                    :allow-column-edit="true" #}
                            {#                    :allow-inline-edit="true" #}
                            {#                    @inline-edit-save="onSaveInlineEdit" #}
                            {#                    @inline-edit-cancel="onCancelInlineEdit" #}
                            {#                > #}

                            <acris-one-to-many-faq-grid
                                    class="acris-faq-group-detail__assigned-faqs"
                                    :is-loading="isLoading"
                                    ref="faqGrid"
                                    :localMode="false"
                                    :collection="assignedFaqs"
                                    :columns="faqColumns"
                                    :compact-mode="true"
                                    :show-actions="true"
                                    :show-selection="false"
                                    :allow-column-edit="true"
                                    :allow-inline-edit="true"
                                    {#                    @inline-edit-save="onSaveInlineEdit" #}
                                    {#                    @inline-edit-cancel="onCancelInlineEdit" #}
                            >

                                {% block acris_faq_group_detail_faqs_column_description %}
                                    <template #column-description="{ item, isInlineEdit }"
                                              class="sw-event-action-list-expand-labels">
                                        {{ getCleanText(item.description) }}
                                    </template>
                                {% endblock %}


                                {#                        {% block acris_faq_group_detail_faqs_pagination %} #}
                                {#                            <sw-pagination :page="page" #}
                                {#                                           :limit="limit" #}
                                {#                                           :total="total" #}
                                {#                                           :total-visible="7" #}
                                {#                                           @page-change="onPageChange"> #}
                                {#                            </sw-pagination> #}
                                {#                        {% endblock %} #}


                            </acris-one-to-many-faq-grid>

                        </mt-card>
                    {% endblock %}

                    {% block acris_faq_group_detail_content_card_cms_page %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-faq-group-content-cms-page"
                                 :title="$tc('acris-faq-group.detail.cardFaqGroupCmsPage')">

                            {% block acris_faq_group_detail_content_card_cms_page_display_type %}
                                <sw-single-select v-model:value="item.cmsPageDisplayType"
                                                  :options="cmsPageDisplayTypeOptions"
                                                  :label="$tc('acris-faq-group.detail.fieldTitleLabelCmsPageDisplayType')">
                                </sw-single-select>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_card_cms_page_before %}
                                <div class="sw-card__title acris-mb-2">{{ $tc('acris-faq-group.detail.fieldTitleFaqGroupCmsPageBefore') }}</div>
                                <acris-generic-cms-page-assignment
                                        :cms-page-id="item.cmsPageBeforeId"
                                        @create-layout="onCreateLayout"
                                        @update:cms-page="updateCmsPageBefore">
                                </acris-generic-cms-page-assignment>
                            {% endblock %}

                            {% block acris_faq_group_detail_content_card_cms_page_after %}
                                <div class="sw-card__title acris-mb-2">{{ $tc('acris-faq-group.detail.fieldTitleFaqGroupCmsPageAfter') }}</div>
                                <acris-generic-cms-page-assignment
                                        :cms-page-id="item.cmsPageAfterId"
                                        @create-layout="onCreateLayout"
                                        @update:cms-page="updateCmsPageAfter">
                                </acris-generic-cms-page-assignment>
                            {% endblock %}
                        </mt-card>
                    {% endblock %}

                </sw-card-view>
            </template>

        {% endblock %}

    </sw-page>
{% endblock %}
